import { theme } from '@/analyses/_shared/theme';

/**
 * Tier = operational difficulty for Menta's resale model.
 *
 *   easy       — plug-and-play (EU clean markets, cross-border + OSS works)
 *   moderate   — Medium: manageable compliance, standard ops model works
 *   restricted — Hard: meaningful restrictions, face-value or local-entity required
 *   blocked    — Not viable today (OFAC, structural bans, no PSP)
 *   not-analyzed — no regulatory analysis yet
 */
export type Tier =
  | 'not-analyzed'
  | 'easy'
  | 'moderate'
  | 'restricted'
  | 'blocked';

export const TIER_CONFIG: Record<
  Tier,
  { color: string; label: string; description: string; order: number }
> = {
  easy: {
    color: theme.GREEN,
    label: 'Easy',
    description: 'Low regulatory complexity. Plug-and-play operation.',
    order: 0,
  },
  moderate: {
    color: theme.YELLOW,
    label: 'Medium',
    description:
      'Manageable compliance burden. Standard operating model works with local adjustments.',
    order: 1,
  },
  restricted: {
    color: theme.RED,
    label: 'Hard',
    description:
      'Significant restrictions or local-entity required. Viable only with strict guardrails.',
    order: 2,
  },
  blocked: {
    color: theme.BLOCKED,
    label: 'Blocked',
    description:
      'Non-viable under current framework. Sanctions, structural bans, or no viable PSP.',
    order: 3,
  },
  'not-analyzed': {
    color: theme.GREY,
    label: 'Not analyzed',
    description: 'No regulatory analysis yet.',
    order: 4,
  },
};

export const TIER_ORDER: Tier[] = [
  'easy',
  'moderate',
  'restricted',
  'blocked',
  'not-analyzed',
];
